var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.0418C9.74163 18.0418 9.49163 18.0085 9.28329 17.9335C6.09996 16.8418 1.04163 12.9668 1.04163 7.24183C1.04163 4.32516 3.39996 1.9585 6.29996 1.9585C7.70829 1.9585 9.02496 2.5085 9.99996 3.49183C10.975 2.5085 12.2916 1.9585 13.7 1.9585C16.6 1.9585 18.9583 4.3335 18.9583 7.24183C18.9583 12.9752 13.9 16.8418 10.7166 17.9335C10.5083 18.0085 10.2583 18.0418 9.99996 18.0418ZM6.29996 3.2085C4.09163 3.2085 2.29163 5.01683 2.29163 7.24183C2.29163 12.9335 7.76663 16.1002 9.69163 16.7585C9.84163 16.8085 10.1666 16.8085 10.3166 16.7585C12.2333 16.1002 17.7166 12.9418 17.7166 7.24183C17.7166 5.01683 15.9166 3.2085 13.7083 3.2085C12.4416 3.2085 11.2666 3.80016 10.5083 4.82516C10.275 5.14183 9.74163 5.14183 9.50829 4.82516C8.73329 3.79183 7.56663 3.2085 6.29996 3.2085Z",
    fill: "#657892"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartGray);
export default __webpack_public_path__ + "static/media/heart-gray.0ee20d68e9d9c53202aa6b08decf4761.svg";
export { ForwardRef as ReactComponent };